import isEmail from 'validator/lib/isEmail';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const schema = {
	'firstName': (value, state) => {
		if (state.touched['firstName']) {
			if (!value) {
				return localize('required-field');
			}
		}
	},
	'lastName': (value, state) => {
		if (state.touched['lastName']) {
			if (!value) {
				return localize('required-field');
			}
		}		
	},
	'companyName': (value, state) => {
		if (state.touched['companyName']) {
			if (!value) {
				return localize('required-field');
			}
		}		
	},
	'nrOfUsers': (value, state) => {
		if (state.touched['nrOfUsers']) {
			if (!value) {
				return localize('required-field');
			}
		}		
	},
	'workEmail': (value, state) => {
		if (state.touched['workEmail']) {
			if (!value) {
				return localize('required-field');
			}
			if (!isEmail(value)) {
				return localize('contact-sales-email-invalid');
			}
		}		
	},
	'jobTitle': (value, state) => {
		if (state.touched['jobTitle']) {
			if (!value) {
				return localize('required-field');
			}
		}		
	},
	'phoneNumber': (value, state) => {
		if (state.touched['phoneNumber']) {
			// eslint-disable-next-line no-useless-escape
			if (value && value.match(/^[0-9\-\+\(\)\s]*$/) === null) {
				return localize('contact-sales-phone-invalid');
			}
		}		
	},
	'usageInfo': (value, state) => {
		if (state.touched['usageInfo']) {
			if (!value) {
				return localize('required-field');
			}
		}		
	},

};

export default schema;


// WEBPACK FOOTER //
// ./src/components/Modal/ContactSalesSchema.js